import React from "react";
import Gene20Box from "../../Components/Gene20Box/Gene20Box";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  Stack,
  TextField,
  Button,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import caterlogueData from "../../routes/data/catalogueRoutesData";
import footerRoutesData from "../../routes/data/footerRoutesData";
import socialMediaRoutes from "../../routes/data/socialMediaRoutes";
import { Call, Place, ThumbUp } from "@mui/icons-material";

export default function Gene20Footer(props) {
  const useStyles = makeStyles(() => ({
    footerCategorie: {},
  }));
  const classes = useStyles();
  const { window, drawerWidth } = props;
  const navigations = (
    <Gene20Box
      sx={{
        cursor: "pointer",
        // ml: "auto",
        mb: "2vh",
        display: { sm: "flex" },
        width: "50%",
        justifyContent: { sm: "space-between" },
      }}
    >
      <Gene20Box sx={{ marginBottom: "2rem" }}>
        <Typography
          display="block"
          variant="heading"
          fontWeight="bold"
          textTransform="upper-case"
          mb="1rem"
        >
          categories
        </Typography>
        <List sx={{ ml: { xs: "1rem", sm: "0" } }}>
          {caterlogueData.map((cater) => (
            <ListItem>
              <ListItemText>
                <Typography
                  display="block"
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize"
                  mb={1}
                >
                  {cater.name}
                </Typography>
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </Gene20Box>
      <Divider sx={{ display: { xs: "block", sm: "none" } }} />
      <Gene20Box>
        <Typography
          display="block"
          variant="heading"
          fontWeight="bold"
          textTransform="upper-case"
          mb="1rem"
        >
          navigation
        </Typography>
        <List sx={{ ml: { xs: "1rem", sm: "0" } }}>
          {footerRoutesData.map((route) => (
            <ListItem>
              <ListItemText>
                <Typography
                  display="block"
                  variant="button"
                  fontWeight="light"
                  textTransform="capitalize"
                  mb={1}
                >
                  {route.name}
                </Typography>
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </Gene20Box>
    </Gene20Box>
  );

  const contact = (
    <>
      <Gene20Box
        display="block"
        mt={3}
        mb={3}
        sx={{
          justifyContent: { xs: "space-between", sm: "left" },
        }}
      >
        <Typography
          display="block"
          variant="title"
          fontWeight="bold"
          textTransform="upper-case"
          mr="1rem"
          mb="1rem"
        >
          get in touch with us
        </Typography>
        <Gene20Box>
          <Typography variant="body2" fontWeight="light" co>
            Any questions? visit our offices @
          </Typography>
          <Gene20Box sx={{ display: "flex" }}>
            <Place sx={{ color: "red" }} />
            <Typography
              variant="body2"
              component={ListItemText}
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: "2rem",
                fontVariant: "all-small-caps",
              }}
            >
              BP 473 Complexe universitaire Al Qods, Oujda 60000
            </Typography>
          </Gene20Box>
          <Typography sx={{ margin: "1rem 4rem" }}>or</Typography>
          <Gene20Box sx={{ display: "flex" }}>
            <Call sx={{ color: "green" }} />
            <Typography
              variant="body2"
              component={ListItemText}
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: "2rem",

                fontVariant: "all-small-caps",
              }}
            >
              call us on (+27) 61 202 3165
            </Typography>
          </Gene20Box>
          <Typography sx={{ margin: "1rem 4rem" }}>or</Typography>
          <Gene20Box sx={{ display: "flex" }}>
            <Typography variant="body2" sx={{ marginRight: "1rem" }}>
              <ThumbUp/> follow us social media
            </Typography>
            {socialMediaRoutes.map((social, key) => (
              <Typography
                // display="flex"
                key={social.name}
                component="a"
                href={social.link}
                target="_blank"
                rel="noreferrer"
                variant="h5"
                color="dark"
                opacity={0.8}
                // mr= "2rem"
                mr={key === social.length - 1 ? 0 : 2.5}
              >
                {social.icon}
              </Typography>
            ))}
          </Gene20Box>
        </Gene20Box>
      </Gene20Box>
      <Gene20Box sx={{ width: "100%" }}>
        <Typography
          display="block"
          variant="heading"
          fontWeight="bold"
          textTransform="upper-case"
          mb={1}
        >
         Subscribe to our newsletter
        </Typography>
        <List>
          <ListItem sx={{ mb: "1rem" }}>
            <Stack spacing={3}>
              <TextField
                placeholder="email@example.com"
                size="10"
                // width="200px"
                fullwidth
              />
            </Stack>
          </ListItem>
          <ListItem>
            <Button variant="contained">Subscribe</Button>
          </ListItem>
        </List>
      </Gene20Box>
    </>
  );
  return (
    <Gene20Box
      component="footer"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        background: "#222",
        pt: "2rem",
        display: "flex",
        cursor: "pointer",
      }}
    >
      <Container>
        <>{navigations}</>
        <>{contact}</>

        <Gene20Box
          align="center"
          sx={{
            display: { sx: "block", sm: "flex" },
            mt: "2rem",
            justifyContent: { sm: "space-between" },
          }}
        >
          <Typography variant="body2" align="center">
            this website is property of
            <Typography
              variant="body2"
              component={ListItemText}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontVariant: "all-small-caps",
              }}
            >
              geneTwenty20 Tech Solutions
            </Typography>
          </Typography>
          <Typography
            sx={{ display: { xs: "none", sm: "block" }, m: "0 1rem" }}
          >
            <Divider />
          </Typography>
          <Typography
            sx={{ m: "1rem", fontVariant: "all-small-caps" }}
            variant="body2"
            align="center"
          >
            copyright ©2021 all rights reserved
          </Typography>
        </Gene20Box>
      </Container>
    </Gene20Box>
  );
}
